import { sortByName } from '@Sage/ssm-utils';

export default class RolesManager {
    constructor(api) {
        this.api = api;
    }

    getRoles = () =>
        this.api.getRoles().then((res) => {
            if (res.rolesList) {
                res.rolesList = res.rolesList.sort(sortByName);
            }
            return res;
        });
}
